'use client';

import { useEffect } from 'react';

import sendAppError from '@/libs/logger/requests/send-app-error';
import styles from "@/_pages/error-page/error-page.module.scss";
import Image from "next/image";
import { ROUTER_LINKS } from "@/shared/constants/links-constants";
import { getUserBearerCookie } from "@/features/user/cookies/cookie-user-bearer";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const isUserLogged = !!getUserBearerCookie();

  useEffect(() => {
    sendAppError({
      cause: error.cause,
      digest: error.digest,
      message: error.message,
      name: error.name,
      stack: error.stack,
    })
      .catch(() => {
        console.error(`[API ERROR - Date ISO: ${new Date().toISOString()}]: Error to send error data to server`);
      });

    console.error(`[APP ERROR - Date ISO: ${new Date().toISOString()}]:`, {
      cause: error.cause,
      digest: error.digest,
      message: error.message,
      name: error.name,
      stack: error.stack,
    });
  }, [error]);

  return (
    <html lang="en">
      <body style={{
        alignItems: 'center',
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        width: '100vw',
      }}
      >
        <div className={styles.errorPage}>
          <div className={styles.errorPage_content}>
            <div className={styles.errorPage_image}>
              <Image
                src="/images/roomster-graphics/sad-girl.svg"
                alt="error image"
                fill
              />
            </div>

            <div className={styles.errorPage_info}>
              <p className={styles.errorPage_title}>
                Sorry
              </p>

              <p className={styles.errorPage_description}>
                Something went wrong...
              </p>

              <div className={styles.errorPage_actions}>
                {reset && (
                  <button
                    className={styles.errorPage_button}
                    onClick={reset}
                  >
                    Try again
                  </button>
                )}

                <a
                  className={styles.errorPage_button}
                  href={ROUTER_LINKS.home}
                >
                  Home
                </a>

                <a
                  className={styles.errorPage_button}
                  href={isUserLogged ? ROUTER_LINKS.help : ROUTER_LINKS.phoneAuth}
                >
                  Help
                </a>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
